import { render, staticRenderFns } from "./billGoods.vue?vue&type=template&id=31406896"
import script from "./billGoods.vue?vue&type=script&lang=js"
export * from "./billGoods.vue?vue&type=script&lang=js"
import style0 from "./billGoods.vue?vue&type=style&index=0&id=31406896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports